import { browser } from '$app/environment';
import { goto } from '$app/navigation';
import { page } from '$app/stores';
import { get } from 'svelte/store';

export const RedirectToUrlKey = 'redirectTo';

/** Equivalent to hitting the back button in the browser. */
export function back(): void {
	window.history.back();
}

/**
 * Navigates to a new page, but without adding a new entry in the browser's history stack.
 * So, clicking on the back button in the browser would not lead to the page users were visiting before the call to this method.
 */
export function replaceUrl(url: string | URL): void {
	window.history.pushState({}, '', url.toString());
}

export function replaceUrlWithNewParam(key: string, value: unknown | null) {
	replaceUrl(getCurrentUrlWithNewParam(key, value));
}

export function getCurrentUrlWithNewParam(key: string, value: unknown | null) {
	let url: URL;
	if (browser) {
		url = new URL(window.location.toString());
	} else {
		url = get(page).url;
	}

	url.searchParams.delete(key);
	if (value != null) {
		if (Array.isArray(value)) {
			value.forEach((part) => url.searchParams.append(key, String(part)));
		} else {
			url.searchParams.set(key, String(value));
		}
	}
	return url;
}

export function gotoWithParams(url: URL, queryParams: Record<string, string | number> = {}) {
	const newUrl = new URL(url);
	Object.entries(queryParams).forEach((keyValue) =>
		newUrl.searchParams.set(keyValue[0], String(keyValue[1]))
	);
	goto(newUrl);
}

export function showDebugInfo(url: URL) {
	return url?.searchParams.get('debug') === 'true';
}

export function isInWebWorker() {
	// @ts-ignore
	return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}
